export function trimAndRemoveExtraSpaces(value: string) {
  return value.replace(/\s+/g, ' ').trim();
}
